import { takeLatest } from 'redux-saga/effects';
import {
    createProductTagWorker, fetchPagesOfProductTagWorker,
    inactivateProductTagWorker, activateProductTagWorker,
} from './productTagWorkerSaga';
import {
    CREATE_PRODUCT_TAG_REQUEST, FETCH_PRODUCT_TAG_LIST_REQUEST,
    INACTIVATE_PRODUCT_TAG_REQUEST, ACTIVATE_PRODUCT_TAG_REQUEST,
} from '../../redux/modules/productTag/productTag-actions';


export function* fetchPagesOfProductTagWatcher() {
    yield takeLatest(FETCH_PRODUCT_TAG_LIST_REQUEST, fetchPagesOfProductTagWorker);
}

export function* createProductTagWatcher() {
    yield takeLatest(CREATE_PRODUCT_TAG_REQUEST, createProductTagWorker);
}

export function* inactivateProductTagWatcher() {
    yield takeLatest(INACTIVATE_PRODUCT_TAG_REQUEST, inactivateProductTagWorker);
}

export function* activateProductTagWatcher() {
    yield takeLatest(ACTIVATE_PRODUCT_TAG_REQUEST, activateProductTagWorker);
}
